import Tippy from '@tippyjs/react';

import Icon from 'components/shared/Icon/Icon';

export const routes = {
  list: {
    initial: { title: 'Select Action', name: 'initial-list' },
    results: {
      title: 'Results List',
      name: 'results-list'
    }
  },
  create: {
    non_erx_prescription: {
      title: 'Create Non eRX Prescription',
      name: 'non_erx_prescription-create'
    },
    referral_order: {
      title: 'Create Referral Order',
      name: 'referral_order-create'
    },
    elab_order: {
      title: (
        <div className="flex items-center gap-1">
          <span>Create Integrated eLab Order</span>
          <Tippy
            className="tippy-dark"
            content="Electronic Labs cannot be edited or canceled within Myriad. Please contact lab directly to modify.">
            <span>
              <Icon icon="info-mono" size={18} />
            </span>
          </Tippy>
        </div>
      ),
      name: 'elab_order-create'
    },
    lab_order: {
      title: 'Create Lab/Imaging Order',
      name: 'lab_order-create'
    }
  },
  edit: {
    non_erx_prescription: {
      title: 'Edit Non eRX Prescription',
      name: 'non_erx_prescription-edit'
    },
    referral_order: {
      title: 'Edit Referral Order',
      name: 'referral_order-edit'
    },
    lab_order: {
      title: 'Edit Lab Order',
      name: 'lab_order-edit'
    }
  },
  preview: {
    initial: {
      title: 'Select Action',
      name: 'initial-preview'
    },
    non_erx_prescription: {
      title: 'Preview Non eRX Prescription',
      name: 'non_erx_prescription-preview'
    },
    referral_order: {
      title: 'Preview Referral Order',
      name: 'referral_order-preview'
    },
    elab_order: {
      title: (
        <div className="flex items-center gap-1">
          <span>Preview Integrated eLab Order</span>
          <Tippy
            className="tippy-dark"
            content="Electronic Labs cannot be edited or canceled within Myriad. Please contact lab directly to modify.">
            <span>
              <Icon icon="info-mono" size={18} />
            </span>
          </Tippy>
        </div>
      ),
      name: 'elab_order-preview'
    },
    lab_order: {
      title: 'Preview Lab Order',
      name: 'lab_order-preview'
    },
    results: {
      title: 'Preview Result',
      name: 'results-preview'
    }
  }
};
